import React from 'react';
export default function DemoDay() {
  return (
    <section className="screen demoday screen-pad">
      <div className="blueprint-grid on-dark" aria-hidden="true"></div>
      <div className="wrap demoday-inner">
        <p className="tag">Screen 05 &middot; Final Transmission</p>
        <h2 className="h1">Demo Day</h2>
        <p className="lede lg">
          October 30, 2026 &middot; Kathmandu Valley.
          <br />
          Five teams present live. <span style={{ whiteSpace: 'nowrap' }}>One mission gets the grand prize.</span>
        </p>
      </div>
    </section>
  );
}
